import Resizer from "react-image-file-resizer";

const MAX_FILE_SIZE = 1000000;
const TARGET_WIDTH = 1024;
const QUALITY_STEP = 5;
const INITIAL_QUALITY = 80;

const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};

export const resizeImageAsync = async (
    imageSrc,
    targetWidth = TARGET_WIDTH,
    maxFileSize = MAX_FILE_SIZE,
    qualityStep = QUALITY_STEP,
    initialQuality = INITIAL_QUALITY
) => {
    const img = new Image();
    img.src = imageSrc;

    return new Promise((resolve, reject) => {
        img.onload = () => {
            const attemptResize = (imageSrc, width, quality) => {
                const file = dataURLtoFile(imageSrc, "resized-image.jpg");

                Resizer.imageFileResizer(
                    file,
                    width,
                    width * (img.height / img.width),
                    "JPEG",
                    quality,
                    0,
                    (uri) => {
                        if (uri.length <= maxFileSize) {
                            resolve(uri);
                        } else if (quality > qualityStep) {
                            attemptResize(uri, width, quality - qualityStep);
                        } else {
                            reject("Image size could not be reduced further.");
                        }
                    },
                    "base64"
                );
            };

            attemptResize(imageSrc, targetWidth, initialQuality);
        };

        img.onerror = () => reject("An error occurred while loading the image.");
    });
};